import React, { Component } from 'react';
import Icon from '@mui/material/Icon';
import PropTypes from 'prop-types';

class QA extends Component {
  constructor(props) {
    super(props);

    this.state = {
      opened: false,
    };

    this.toggle = this.toggle.bind(this);
  }

  toggle() {
    this.setState({
      opened: !this.state.opened,
    });
  }

  render() {
    const { opened } = this.state;
    const { question, answer } = this.props;
    return (
      <li>
        <span onClick={this.toggle} className="title-qa">
          <Icon>{opened ? 'keyboard_arrow_up' : 'keyboard_arrow_down'}</Icon>
          {question}
        </span>
        {opened && <div className="content-qa">{answer}</div>}
      </li>
    );
  }
}

QA.propTypes = {
  question: PropTypes.string,
  answer: PropTypes.string,
};

export default QA;
